const ReservationEndpoint = {
  index(company_id) {
    return {
      url: `/orders?company_id=${company_id}`,
      method: 'GET'
    }
  },
  show(orderId) {
    return {
      url: `/orders/${orderId}`,
      method: 'GET'
    }
  },
  new(company_id) {
    return {
      url: 'company',
      method: 'GET'
    }
  },
  create_keg_information(form) {
    return {
      url: '/keg_size_infos',
      method: 'POST',
      body: JSON.stringify({reservation: form})
    }
  },
  create_personal_information(form) {
    return {
      url: '/personal_informations',
      method: 'POST',
      body: JSON.stringify({reservation: form})
    }
  },
  create_form_three(form) {
    return {
      url: '/form_three',
      method: 'POST',
      body: JSON.stringify({reservation: form})
    }
  },
  search(query) {
    return {
      url: `/reservation_search?query=${query}`,
      method: 'GET'
    }
  },
  cancel(form) {
    return {
      url: '/cancel_order',
      method: 'POST',
      body: JSON.stringify({reservation: form})

    }
  },
  refund(form) {
    return {
      url: '/refund_charge',
      method: 'POST',
      body: JSON.stringify({reservation: form})

    }
  },
  cancel_deposit(form) {
    return {
      url: '/cancel_deposit',
      method: 'POST',
      body: JSON.stringify({reservation: form})

    }
  },
  applyDiscount(form) {
    return {
      url: '/apply_discount',
      method: 'PUT',
      body: JSON.stringify({reservation: form})
    }
  },
  verifyReservation(form) {
    return {
      url: '/verify_reservation',
      method: 'PUT',
      body: JSON.stringify({reservation: form})
    }
  },
  deleteReservation(id) {
    return {
      url: `/orders/${id}`,
      method: 'DELETE',
    }
  }
}

export default ReservationEndpoint



// WEBPACK FOOTER //
// ./src/persistence/ReservationEndpoint.js